import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const REASON_LABELS = {
  no_active_subscription: 'Ingen aktiv prenumeration',
  subscription_expired: 'Prenumerationen har löpt ut',
  subscription_suspended: 'Prenumerationen är pausad',
  plan_limit_users_exceeded: 'Maxantal användare uppnått',
  plan_limit_cases_exceeded: 'Maxantal ärenden uppnått',
  plan_limit_verksamheter_exceeded: 'Maxantal verksamheter uppnått',
  ai_quota_exceeded: 'AI-kvoten är förbrukad',
  feature_not_in_plan: 'Funktionen ingår inte i din plan',
  grace_period_active: 'Resperiod aktiv',
};

const SubscriptionBlockedModal = () => {
  const [blocked, setBlocked] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (e) => {
      setBlocked(e.detail);
    };
    window.addEventListener('subscription-blocked', handler);
    return () => window.removeEventListener('subscription-blocked', handler);
  }, []);

  if (!blocked) return null;

  const label = REASON_LABELS[blocked.reason_code] || 'Prenumerationsproblem';

  return (
    <div className="fixed inset-0 bg-black/25 z-[9999] flex items-center justify-center p-4">
      <div className="bg-white rounded-lg p-8 max-w-md w-full shadow-2xl border-2 border-primary">
        <div className="text-center">
          <div className="w-16 h-16 bg-primary/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
          <h2 className="text-2xl font-heading font-black text-foreground mb-2">{label}</h2>
          <p className="text-muted-foreground mb-6">{blocked.message}</p>
          <div className="flex gap-3 justify-center">
            <button
              onClick={() => {
                setBlocked(null);
                navigate('/settings/subscription');
              }}
              className="bg-primary text-primary-foreground font-bold rounded-full px-8 py-3 hover:bg-primary/90 transition-all"
            >
              Visa prenumeration
            </button>
            <button
              onClick={() => setBlocked(null)}
              className="border-2 border-secondary text-secondary rounded-full px-8 py-3 font-bold hover:bg-secondary hover:text-white transition-all"
            >
              Stäng
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionBlockedModal;
